import { useEffect } from "react";

const ClickOutsideWrapper = ({ children, onClose, className, ignoreSelector, style }) => {
    
    useEffect(() => {
        function handleMouseDown(event) {
            const element = event.target;

            const ignoreList = Array.isArray(ignoreSelector)
                ? ignoreSelector
                : ignoreSelector
                    ? [ignoreSelector]
                    : [];

            const shouldIgnore = ignoreList.some((selector) =>
                element.closest(`.${selector}`)
            );

            if (shouldIgnore) return;

            // If click is outside wrapper → close
            if (!element.closest(".click-outside")) {
                onClose();
            }
        }

        document.addEventListener("mousedown", handleMouseDown);
        return () => {
            document.removeEventListener("mousedown", handleMouseDown);
        };
    }, [onClose, ignoreSelector])

    return (
        <div className={`click-outside ${className || ""}`} style={style}>
            {children}
        </div>
    );
};

export default ClickOutsideWrapper;
